const common = {
  serverError: '伺服器錯誤',
  networkError: '網路錯誤',

  del: '刪除',
  rmTip: '刪除提示',
  rmContent: '你確定要刪除這個資料嗎？刪除後資料不可恢復！ ',
  rmError: '刪除失敗',
  rmSuccess: '刪除成功',

  confirm: '確定',
  cancel: '取消',
  cancelConfirm: '資料有改動，確定不進行保存嗎？ ',

  add: '新增',
  addError: '新增失敗',
  addSuccess: '新增成功',

  edit: '編輯',
  editError: '編輯失敗',
  editSuccess: '編輯成功',
  tip: '提示',

  opt: '操作',
  viewDetail: '查看詳情',
  detail: '詳情',

  desc: '描述',
  plDesc: '請輸入描述',

  pass: "通過",
  no: "否",
  copy: '複製',
  copyError: '複製失敗',
  copySuccess: '複製成功',

  printInfo: '列印',
  printInfoQC: '列印QC質檢單',
  paste: '貼上',
  pasteError: '貼上失敗, 請確認複製內容正常或重新複製後再試',

  select: '選擇',
  searchError: "取得清單異常",

  timeOption12: '12小時',
  timeOption24: '1天',
  timeOption36: '36小時',
  timeOption48: '2天',
  timeOption72: '3天',
  timeOption96: '4天',
  timeOption120: '5天',
  currentTime: '當前時間',
  selectTime: '請選擇或填入可供供應商報價的時間段',
  or: '或',
  inputHours: '輸入小時數',
  hour: '小時',
  finalEnd: '最終報價截止時間',
  upper: '當前時間向上取整後',
  plus: '加上',

  refresh: "刷新",
  sure: '確定要保存嗎？',
  saveOk: '保存成功',
  saveFAil: '儲存失敗',
  save: '保存',
  notSave: '不保存',
  validateFailed: '表單校驗失敗',

  createTime: "製單時間",
  creator: "製單人",
  updateTime: '更新時間',
  updater: '更新人',
  pleaseTryAgain: '請稍後重試',
  operationFailed: '操作失敗',

  exportCurrentPage: '匈出當頁Excel',
  exportAllExcel: '匈出全部Excel',
  exporting: '正在匈出',
  exportingTip: '正在批次載入資料，請稍候...',
  exportErr: '匈出失敗',
  warning: '警告',
  pleaseSelectColumns: '請至少選擇一列進行匈出',
  selectAll: '全選',
  expand: '展開更多',
  collapse: '收起',

  basicInfo: '基本資訊',
  attachment: '附件',
  noOutOrder: '沒有出庫單',
  deleteSuccess: '刪除成功',
  deleteFail: '刪除失敗',
  batchDel: '批次刪除',
  selectLeastOne: '請至少選擇一項',
  versionFalse: "請求發起失敗，您的版本不正確，請您刷新頁面重試",
  po: "採購訂單",
  poi: "採購訂單條目",
  so: "銷售訂單",
  soi: "銷售訂單條目",
  io: "入庫單",
  ioi: "入庫單條目",
  oo: "出庫單",
  ooi: "出庫單條目",
  co: "盤點單",
  coi: "盤點單條目",
  act: "應收",
  acti: "應收條目",
  pay: "應付",
  payi: "應付條目",
  req: "需求單",
  reqi: "需求單條目",
  quo: "問詢單",
  loc: "庫位",
  sp: "銷售價格",
  pp: "採購價格",
  cd: "盤點差異",
  user: "用戶/user",
  org: "組織/org",
  supplier: "供應商",
  bom: "BOM",
  pl: "生產計劃",
  reqest: "申請",
  export: "導出",
  inventories: "送貨單",
  matPurTmp: "匹配採購單模板下載",
  genPuInv: "匹配採購單生成送貨單",
  suppInv: "匹配供應商生成送貨單",
  printSaleIn: "成品入庫打印",
  saleIn: "成品入庫",
  lotGetErr: "批次生成失敗，請聯繫管理員",
  addNext: "下一個",
  genLot: "生成",
  noCodeWarn: "沒有存貨編碼的條目不會生成批次",
  genAllLot: "一鍵生成批次",
  colSet: "選擇顯示列",
  leastSetOneCol: "至少選擇一列顯示！",
  reqCanceled: "查詢請求已取消",
  escPressed: "您按下了 ESC，取消了這個查詢請求",
  noFiles: "沒有文件",
};

export default common;
